import { FC } from "react";
import {
  TableHead,
  TableRow,
  TableCell,
  Typography,
  TableSortLabel,
} from "@mui/material";
import { useCollectionsContext } from "../hooks/useCollectionsContext";
import type { SortableTableField } from "../types";

/**
 * Table headers component for the collections table.
 * Displays the table headers and handles sorting.
 */
export const CollectionsTableHeaders: FC = () => {
  const { sortConfig, sortByColumn, filterBy } = useCollectionsContext();

  const getSortDirection = (field: SortableTableField) => {
    if (sortConfig?.field === field) {
      return sortConfig.direction;
    }
    return "desc";
  };

  const headers = [
    { label: "Name", sortField: "name" as SortableTableField },
    { label: "Type" },
    { label: "Count" },
    { label: "Last Updated", sortField: "updated_at" as SortableTableField },
    ...(filterBy === "shared" ? [{ label: "Owner" }] : []),
    { label: "" }, // Actions column without header text
  ];

  return (
    <TableHead>
      <TableRow>
        {headers.map((header, index) => (
          <TableCell key={`${header.label}-${index}`}>
            {header.sortField ? (
              <TableSortLabel
                active={sortConfig?.field === header.sortField}
                direction={getSortDirection(header.sortField)}
                onClick={() => sortByColumn(header.sortField!)}
                sx={{ cursor: "pointer" }}
              >
                <Typography variant="subtitle2" fontWeight={600}>
                  {header.label}
                </Typography>
              </TableSortLabel>
            ) : (
              <Typography variant="subtitle2" fontWeight={600}>
                {header.label}
              </Typography>
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};
